import { motion } from "framer-motion";
import { Crown, TrendingUp, Users, Megaphone } from "lucide-react";
import { fadeUp, stagger } from "./motion";
import { IMAGES } from "@/lib/site";

const rewards = [
  { icon: Crown, title: "Pioneer Bragging Rights", body: "Early adopters are minted as founding members of the social-good crypto movement. First in, loudest voice." },
  { icon: TrendingUp, title: "Aligned Upside", body: "As the community grows, so does the mission war-chest. Your hold and the cause rise together." },
  { icon: Users, title: "HRS Army Access", body: "Governance signal, community drops, and a seat in shaping which programs get funded next." },
  { icon: Megaphone, title: "Real-World Receipts", body: "Impact reporting on shelters funded, outreach hours, and lives changed — transparency on-chain." },
];

export const Rewards = () => {
  return (
    <section id="rewards" className="relative py-24 sm:py-32 px-5 sm:px-6" data-testid="rewards-section">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#00f0ff] mb-4">Why $AHHH</div>
          <h2 className="font-display font-black uppercase tracking-tighter leading-none text-4xl sm:text-5xl mb-6">
            Hold the meme. <br /> Earn the <span className="hero-gradient-text">rewards.</span>
          </h2>
          <p className="font-mono text-sm text-white/60 leading-relaxed mb-8 max-w-md">
            $AHHH isn&apos;t about empty hype — it&apos;s impact you can flex. Here&apos;s what
            the King of Pump gives back to the flock.
          </p>
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
            className="rounded-2xl overflow-hidden border border-white/10 glow-cyan"
          >
            <img src={IMAGES.comic} alt="Screaming Chicken — King of Pump" className="w-full h-auto" />
          </motion.div>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="lg:col-span-7 grid sm:grid-cols-2 gap-6"
        >
          {rewards.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={i}
                variants={fadeUp}
                className="rounded-2xl border border-white/10 bg-[#101010] p-7 hover:border-[#00f0ff] transition-colors"
                data-testid={`reward-card-${i}`}
              >
                <span className="w-11 h-11 rounded-lg bg-[#00f0ff]/10 grid place-items-center mb-5">
                  <Icon className="w-5 h-5 text-[#00f0ff]" />
                </span>
                <h3 className="font-display font-bold uppercase tracking-tight text-lg mb-2">{r.title}</h3>
                <p className="font-mono text-sm text-white/55 leading-relaxed">{r.body}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
